import PageTabs from '@/components/page/PageTabs';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors';
import { query } from '@/redux/selectors/querySelectors';
import OutputViewerSection from '../OutputViewerSection';

const labels = {
  data: 'Sent Payload',
  originalData: 'Original Payload',
  args: 'Original Body'
};

const PayloadSection = ({ request }) => {
  const { arguments: args, data, originalData } = request;

  const tabData = [
    { key: 'data', value: data },
    { key: 'originalData', value: originalData },
    { key: 'args', value: args?.body }
  ].filter((n) => !!n.value);

  const tabKey = 'payloadSectionTab';
  const defaultTab = tabData[0]?.key || 'data';
  const activeTab = useArgSelector(query, tabKey) || defaultTab;

  const childrenMap = {};
  const items = [];

  tabData.forEach((n) => {
    childrenMap[n.key] = <OutputViewerSection.CodeBlock code={n.value} />;
    items.push({ value: n.key, label: labels[n.key] });
  });

  if (!data && !originalData && !args) {
    return (
      <OutputViewerSection className={'py-2'}>
        <OutputViewerSection.CodeBlock code={request} />
      </OutputViewerSection>
    );
  }

  return (
    <OutputViewerSection className={'py-2'}>
      <PageTabs items={items} tabKey={tabKey} defaultTab={defaultTab} />
      <div className="content">{activeTab !== undefined && childrenMap[activeTab]}</div>
    </OutputViewerSection>
  );
};

export default PayloadSection;
